<template>
  <el-dialog
    :title="dialogTitle"
    append-to-body
    :visible="dialogVisible"
    :close-on-click-modal="false"
    width="80%"
    @close="closeDialog"
  >
    <div>
      <SiruiSearch
        ref="abnormalDialogRef"
        :query="abnormalData"
        labelWidth="120px"
        :columns="abnormalForm"
        :isQueryPanel="false"
        :rules="abnormalFormRules"
      ></SiruiSearch>
    </div>
    <div v-if="abnormalData.hasExceptionExpense === '1'">
      <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent()">{{
            '新建费用'
          }}</vxe-button>
          <!-- <vxe-button type="primary" class="vxe-btn-primary" @click="edit()">{{
          '编辑费用'
        }}</vxe-button> -->
          <vxe-button
            type="primary"
            class="vxe-btn-delete"
            @click="handleDelete('costTable')"
            :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
            >{{ '删除' }}</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        width="100%"
        align="left"
        show-header-overflow
        class="vxe-table-element"
        show-footer
        :auto-resize="true"
        border
        resizable
        show-overflow
        :data="goodsTableData"
        :edit-config="editConfig"
        size="mini"
        ref="costTable"
        :max-height="$store.state.app.tableHeight"
        :edit-rules="costEditRules"
      >
        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
        <vxe-table-column
          field="expenseName"
          title="费用类型"
          :edit-render="{
            name: 'ElInput',
            defaultValue: '',
            props: { clearable: true, maxlength: 32 },
          }"
        ></vxe-table-column>
        <vxe-table-column
          field="settleUnitPriceExcludeTax"
          title="结算单价(含税)"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              :max="'99999999999.99'"
              v-model="scope.row.settleUnitPriceExcludeTax"
              precision="2"
              @input="(val) => handleSettleTax(val, scope.row, scope)"
            ></input-number> </template
        ></vxe-table-column>
        <vxe-table-column field="settleQty" title="结算数量" :edit-render="{ type: 'default' }">
          <template v-slot:edit="scope">
            <el-input
              :max="'99999999999'"
              v-model.number="scope.row.settleQty"
              @input="(val) => handleSettleQty(val, scope.row, scope)"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column field="settleAmoutExcludeTax" title="结算金额(含税)"></vxe-table-column>
        <vxe-table-column
          field="receiptMethod"
          title="付款/收款"
          :edit-render="{ name: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select v-model="scope.row.receiptMethod" :clearable="true" filterable>
              <el-option
                v-for="item in receiptMethodList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelectLabel(row.receiptMethod, receiptMethodList)
          }}</template>
        </vxe-table-column>
        <!-- <vxe-table-column field="receiptMethod" title="付款/收款">
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.receiptMethod" :clearable="true">
            <el-option
              v-for="item in receiptMethodList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelectLabel(row.receiptMethod, receiptMethodList)
        }}</template>
      </vxe-table-column> -->
      </vxe-table>
    </div>
    <div slot="footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { abnormalForm, abnormalFormRules } from '../data';
  import API from '@/api/intermodality/order';
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  export default {
    name: 'abnormalDialog',
    props: ['dialogTitle', 'dialogVisible', 'isEdit', 'editVal'],
    components: {
      SiruiSearch,
    },
    computed: {
      costEditRules() {
        return {
          expenseName: [
            {
              required: true,
              message: '费用类型必填',
              trigger: ['blur', 'change'],
            },
          ],
          settleUnitPriceExcludeTax: [
            {
              required: true,
              message: '结算单价(不含税)必填',
              trigger: ['blur', 'change'],
            },
          ],
          settleQty: [
            {
              required: true,
              message: '结算数量必填',
              trigger: ['blur', 'change'],
            },
          ],
          settleAmoutExcludeTax: [
            {
              required: true,
              message: '结算金额(不含税)必填',
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
    },
    ...mapState({
      userInfo: (state) => state.userInfo.userInfo,
    }),
    data() {
      return {
        abnormalData: {
          exceptionCode: '',
          exceptionDescription: '',
          exceptionType: '',
          exceptionReason: '',
          hasExceptionExpense: '',
          remarks: '',
        },
        abnormalForm,
        abnormalFormRules,
        editConfig: { trigger: 'dblclick', mode: 'row' },
        goodsTableData: [],
        receiptMethodList: [
          {
            label: '付款',
            value: '01',
          },
          {
            label: '收款',
            value: '02',
          },
        ],
      };
    },
    created() {
      if (this.isEdit) {
        this.dealData();
      }
    },
    methods: {
      //转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      handleSettleQty(val, row, scope) {
        if (val) {
          if (row.settleUnitPriceExcludeTax) {
            row.settleAmoutExcludeTax = Number(
              (val * (row.settleUnitPriceExcludeTax * 10)) / 10
            ).toFixed(2);
            this.$refs.costTable.reloadRow(row);
            this.$refs.costTable.updateStatus(scope);
          }
        }
      },
      handleSettleTax(val, row, scope) {
        if (val) {
          if (row.settleQty) {
            row.settleAmoutExcludeTax = Number((val * 10 * row.settleQty) / 10).toFixed(2);
            this.$refs.costTable.reloadRow(row);
            this.$refs.costTable.updateStatus(scope);
          }
        }
      },
      dealData() {
        console.log(this.editVal, 'this.editVal');
        const obj = {
          exceptionCode: this.editVal.exceptionCode,
          exceptionDescription: this.editVal.exceptionDescription,
          exceptionType: this.editVal.exceptionType,
          exceptionReason: this.editVal.exceptionReason,
          hasExceptionExpense: this.editVal.hasExceptionExpense + '',
          remarks: this.editVal.remarks,
        };
        Object.assign(this.abnormalData, obj);
        this.goodsTableData = this.editVal.orderExceptionExpenses || [];
      },
      closeDialog(va) {
        this.$emit('close', va);
      },
      sure() {
        this.$refs.abnormalDialogRef.validate((valid) => {
          if (valid) {
            if (this.abnormalData.hasExceptionExpense === '1') {
              this.$refs['costTable'].validate((va) => {
                if (va) {
                  const params = {};
                  Object.assign(params, this.abnormalData);
                  const abnormalTableData = this.$refs.costTable.getTableData().fullData || [];
                  params.orderExceptionExpenses = abnormalTableData;
                  params.createByName = this.userInfo.personName;
                  params.orderCode = this.$route.query.orderCode;
                  if (this.isEdit) {
                    params.id = this.editVal.id;
                  }
                  this.$axios.post(API.SAVE_ORDER_ABNORMAL, params).then((res) => {
                    if (res.data.code === 0) {
                      this.$message({
                        showClose: true,
                        message: this.isEdit ? '编辑异常成功' : '新建异常成功',
                        type: 'success',
                      });
                      this.closeDialog('sure');
                    }
                  });
                }
              });
            } else {
              const params = {};
              Object.assign(params, this.abnormalData);
              // const abnormalTableData = this.$refs.costTable.getTableData().fullData || [];
              params.orderExceptionExpenses = [];
              params.createByName = this.userInfo.personName;
              params.orderCode = this.$route.query.orderCode;
              if (this.isEdit) {
                params.id = this.editVal.id;
              }
              this.$axios.post(API.SAVE_ORDER_ABNORMAL, params).then((res) => {
                if (res.data.code === 0) {
                  this.$message({
                    showClose: true,
                    message: this.isEdit ? '编辑异常成功' : '新建异常成功',
                    type: 'success',
                  });
                  this.closeDialog('sure');
                }
              });
            }
          }
        });
      },
      handleDelete(tableType) {
        console.log(tableType, 'tableType');
        const selectedList = this.$refs[tableType].getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.noChooseDel'),
            type: 'error',
          });
          return;
        }
        this.$refs[tableType].removeSelecteds();
      },
      insertEvent() {
        console.log('costEditRules');
        this.$refs['costTable'].validate((valid) => {
          if (valid) {
            let record = {
              expenseName: '',
              settleUnitPriceExcludeTax: '',
              settleQty: '',
              settleAmoutExcludeTax: '',
              receiptMethod: '',
            };
            this.$refs.costTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.costTable.setActiveRow(row));
          }
        });
      },
    },
  };
</script>
